import { useNavigate } from "react-router-dom";
import Header from "./Header";
import { Card } from "./ui/card";
import { Badge } from "./ui/badge";
import { Button } from "./ui/button";
import { brl } from "./PurchaseDialog";
import { ShoppingBag, Send, Network, ArrowRight } from "lucide-react";

const UpgradeCard = ({ u, onGo }) => {
  const deadline = u.buyer_deadline ? new Date(u.buyer_deadline).toLocaleDateString("pt-BR") : null;
  return (
    <Card className="p-6 gold-border lg:col-span-2" data-testid="buyer-upgrade-card">
      <div className="flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-muted-foreground">
        <Network className="h-4 w-4" /> Vire Associado Ativo
      </div>
      <p className="mt-3 text-sm">
        Pague a adesão de <b className="gold-text">R$ 39,90</b> e entre automaticamente na matriz 5x4 com direito a comissões
        do 1º ao 4º nível, Saldo Consumo e saque via Pix.
      </p>
      <p className="mt-2 text-xs text-muted-foreground" data-testid="buyer-deadline">
        {u.buyer_restricted
          ? "O prazo de 2 meses para ativação terminou: sua conta está restrita ao perfil de Comprador. Você ainda pode ativar o plano a qualquer momento."
          : `Prazo para ativar como associado: até ${deadline}. Depois disso a conta fica restrita ao perfil de Comprador.`}
      </p>
      <Button className="gold-btn mt-4" onClick={onGo} data-testid="buyer-upgrade-btn">
        Ativar plano R$ 39,90 <ArrowRight className="h-3 w-3 ml-2" />
      </Button>
    </Card>
  );
};

export const BuyerHome = ({ u }) => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen">
      <Header />
      <div className="pt-24 pb-16 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Área do Comprador</div>
        <div className="flex flex-wrap items-center gap-3 mt-1 mb-8">
          <h1 className="font-display text-3xl sm:text-4xl font-bold">Olá, <span className="gold-text">{u.name.split(" ")[0]}</span></h1>
          <Badge variant="outline" className="text-sky-500 border-sky-500/50" data-testid="buyer-badge">
            {u.buyer_restricted ? "Comprador (restrito)" : "Comprador"}
          </Badge>
        </div>
        <div className="grid lg:grid-cols-3 gap-6">
          <Card className="p-6" data-testid="buyer-balance-card">
            <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Saldo disponível</div>
            <div className="mt-2 font-mono text-3xl font-bold gold-text" data-testid="buyer-balance">{brl(u.balance)}</div>
            <p className="text-xs text-muted-foreground mt-1">Recebido por transferências — use nas compras da loja.</p>
            <div className="flex flex-wrap gap-2 mt-4">
              <Button size="sm" className="gold-btn" onClick={() => navigate("/beneficios")} data-testid="buyer-store-btn">
                <ShoppingBag className="h-3 w-3 mr-2" /> Ir para a loja
              </Button>
              <Button size="sm" variant="outline" onClick={() => navigate("/transferir")} data-testid="buyer-transfer-btn">
                <Send className="h-3 w-3 mr-2" /> Transferências
              </Button>
            </div>
          </Card>
          <UpgradeCard u={u} onGo={() => navigate("/aguardando-ativacao")} />
        </div>
      </div>
    </div>
  );
};
